import ApiClient from './apiClient'
import { DesktopAppInstallerLinkResponse, DesktopAppVersionCheckResponse } from '../types/desktopApp'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDesktopAppInstallerLink = async (): Promise<any> => ApiClient.get(
  '/api/v2/renderer/desktop_app/installer_link',
  (result: DesktopAppInstallerLinkResponse) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDesktopAppVersionCheck = async (): Promise<any> => ApiClient.get(
  '/api/v1/renderer/header/desktop_app/version_check',
  (result: DesktopAppVersionCheckResponse) => result,
)
